import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useOfflineSync } from "../../providers/OfflineSyncProvider";
import {
  saveAttendanceDraft,
  submitAttendanceFlow,
  saveMarksDraft,
  submitMarksFlow,
} from "../../offline/teacherApi";

export function useSaveAttendanceDraftMutation(teacherId) {
  const queryClient = useQueryClient();
  const { queueMutation } = useOfflineSync();

  return useMutation({
    mutationFn: (payload) => saveAttendanceDraft(payload),
    onSuccess: async (result) => {
      if (result.queued) await queueMutation();
      await queryClient.invalidateQueries({
        queryKey: ["attendanceSubmissions", String(teacherId)],
      });
    },
  });
}

export function useSubmitAttendanceMutation(teacherId) {
  const queryClient = useQueryClient();
  const { queueMutation } = useOfflineSync();

  return useMutation({
    mutationFn: ({ payload, submissionId }) => submitAttendanceFlow(payload, submissionId),
    onSuccess: async (result) => {
      if (result.queued) await queueMutation();
      await queryClient.invalidateQueries({
        queryKey: ["attendanceSubmissions", String(teacherId)],
      });
    },
  });
}

export function useSaveMarksDraftMutation(teacherId) {
  const queryClient = useQueryClient();
  const { queueMutation } = useOfflineSync();

  return useMutation({
    mutationFn: (payload) => saveMarksDraft(payload),
    onSuccess: async (result) => {
      if (result.queued) await queueMutation();
      await queryClient.invalidateQueries({
        queryKey: ["marksSubmissions", String(teacherId)],
      });
    },
  });
}

export function useSubmitMarksMutation(teacherId) {
  const queryClient = useQueryClient();
  const { queueMutation } = useOfflineSync();

  return useMutation({
    mutationFn: ({ payload, submissionId }) => submitMarksFlow(payload, submissionId),
    onSuccess: async (result) => {
      if (result.queued) await queueMutation();
      await queryClient.invalidateQueries({
        queryKey: ["marksSubmissions", String(teacherId)],
      });
    },
  });
}
